/** Strings for the livechat page header: tools menu, agent menu, test mode and availability hints. */
export const translationLivechat_en_header = {
  livechatToolsMenuLabel: "Settings and tools",
  livechatSettingsHint: "Availability, widget, translation, routing, inactive chats and data",
  livechatCannedResponsesHint: "Manage saved replies",
  livechatGroupsHint: "Choose who receives routed chats",
  livechatTestMode: "Test mode",
  livechatTestModeHint: "Show chats from test portals only",
  livechatTestModeBarTitle: "Test mode.",
  livechatTestModeBarText:
    "You see chats from test portals only. Live chats keep arriving in the live queue.",
  livechatBackToLive: "Back to live",
  livechatAgentMenuLabel: "Your agent profile and notifications",
  livechatAgentProfileHint: "Name, picture and languages visitors see",
  livechatAgentProfileHintAllChatbots: "Name, picture and languages visitors see on every chatbot",
  livechatNotifyMe: "Notify me",
  livechatPopupShort: "Pop-ups",
  livechatPopupHint: "A toast when there is new live chat activity",
  livechatOtherAgentsShort: "Chats handled by other agents",
  livechatOtherAgentsHint: "When off, only your own and unassigned chats alert you",
  livechatGoOnlineHint: "Also outside opening hours",
  livechatGoOfflineHint: "Visitors see the contact form",
  livechatUseScheduleHint: "Follow each chatbot’s opening hours",
  livechatAvailabilityOneChatbot: "Change one chatbot",
  livechatEditOpeningHours: "Edit opening hours",
};
